import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-447e6e0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "customer-infos-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "登録情報", -1))
const _hoisted_3 = { class: "customer-infos-body-wrapper grid" }
const _hoisted_4 = { class: "p-card p-component" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 label" }, "お名前", -1))
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "block mb-1" }
const _hoisted_9 = {
  key: 0,
  class: "block"
}
const _hoisted_10 = {
  key: 0,
  class: "grid"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 label" }, "生年月日", -1))
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "block" }
const _hoisted_14 = { class: "grid" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 label" }, "性別", -1))
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "block" }
const _hoisted_18 = {
  key: 1,
  class: "grid"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 label" }, "連絡先", -1))
const _hoisted_20 = { class: "col" }
const _hoisted_21 = {
  key: 0,
  class: "block mb-1"
}
const _hoisted_22 = {
  key: 1,
  class: "block mb-1"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1))
const _hoisted_24 = {
  key: 2,
  class: "block"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-clock" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "予約確認", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-user" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "会員情報", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

import axios from "axios";
import moment from "moment";
import { onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import RouterConstants from "@/customer/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import ApiRouterConstants from "@/common/constants/api.router.constants";
import { GenderEnum } from "@/clinic/typings/enums/customer";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerInfos',
  setup(__props) {

const store = useStore();
const route = useRoute();
const customerInfos = ref({});

const goToBookingHistory = () => {
  const { clinic_id } = route.query;

  RouterUtils.goToWithQuery(RouterConstants.BOOKING_HISTORY_ROUTER_NAME, {
    clinic_id: clinic_id || store.getters["line_account/clinicId"],
  });
};

const goToCustomerInfos = () => {
  const { clinic_id } = route.query;

  RouterUtils.goToWithQuery(RouterConstants.CUSTOMER_INFOS_ROUTER_NAME, {
    clinic_id: clinic_id || store.getters["line_account/clinicId"],
  });
};

onBeforeMount(async () => {
  const { clinic_id } = route.query;
  const res = await axios.get(`${ApiRouterConstants.API_CUSTOMERS}/info`, {
    params: {
      clinic_id: clinic_id || store.getters["line_account/clinicId"],
      line_account_id: store.getters["line_account/id"],
    },
    headers: { Accept: "application/json" },
  });
  customerInfos.value = res.data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(customerInfos.value.name), 1),
            (customerInfos.value.name_kana)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(customerInfos.value.name_kana), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (customerInfos.value.birthday)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(moment)(customerInfos.value.birthday).format("YYYY/MM/DD")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(GenderEnum)[customerInfos.value.gender]), 1)
          ])
        ]),
        (customerInfos.value.zipcode || customerInfos.value.email || customerInfos.value.phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                (customerInfos.value.zipcode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "〒 " + _toDisplayString(customerInfos.value.zipcode), 1))
                  : _createCommentVNode("", true),
                (customerInfos.value.email)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _hoisted_23,
                      _createTextVNode(" " + _toDisplayString(customerInfos.value.email), 1)
                    ]))
                  : _createCommentVNode("", true),
                (customerInfos.value.phone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      _hoisted_25,
                      _createTextVNode(" " + _toDisplayString(customerInfos.value.phone), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", { class: "fixed-bottom-menu flex justify-content-center" }, [
      _createElementVNode("div", {
        class: "btn-wrap flex flex-column justify-content-center align-items-center cursor-pointer",
        onClick: goToBookingHistory
      }, _hoisted_28),
      _createElementVNode("div", {
        class: "btn-wrap flex flex-column justify-content-center align-items-center cursor-pointer",
        onClick: goToCustomerInfos
      }, _hoisted_31)
    ])
  ]))
}
}

})